import { $Q } from "../utils/query-selector";
import { validateRegisterCustomer } from "../utils/validate-customer"
import { registerEmailInKlaviyo } from '../services/klaviyo';
import { getLang } from "../utils/get-lang";

/**
 * Register a new customer in Klaviyo with language
 */
export const createCustomerWithLang = (email) => {
  getLang(email)
}

export const customSubmitNewsletter = () => {
  const button = $Q('.klaviyo-form-TvKjEs form button')
  if (!button) return
  button.addEventListener('click', (e) => {
    e.preventDefault()
    let email = $Q(".klaviyo-form-TvKjEs form input[type='email']").value
    if (!email) return;
    createCustomerWithLang(email)
    form.submit()
  })
}

export const isRegisteredUser = () => {
  // eslint-disable-next-line no-undef
  const isRegistered = validateRegisterCustomer();

  if (isRegistered) {
    if ($Q('.error-js')) $Q('.error-js').style.display = "block";
    if ($Q('input[type="email"]')) $Q('input[type="email"]').value = "";
  }
}

/**
 * Custom redirect in the same page
 */
export const newsletterSubmit = () => {
  window.addEventListener("DOMContentLoaded", function(event) {
    event.preventDefault();

    const urlSearch = window.location.search.includes('?customer_posted=true') || validateRegisterCustomer()
    if (!urlSearch) return

    const hash = window.location.hash;

    if (hash) {
      const target = document.querySelector(hash);
      history.replaceState(null, null, window.location.href.split('#')[0])

      if (target) {
        const html = $Q('html')
        if (html) html.style.scrollBehavior = 'smooth'

        window.scrollTo(
          0,
          target.getBoundingClientRect().top - (target.getBoundingClientRect().height) // Distance less height
        )

        html && html.removeAttribute('style')
      }
    }
  });
}
